import { useEffect } from 'react';
import { Spinner } from './ui/Spinner';
import { redirectToToolsLogin, type ToolsLoginApp } from '../lib/tools-login';

/**
 * ToolsLoginRedirect — was DAM und Transfer ab dem P1c-Cutover anstelle einer
 * LoginPage rendern (Must 10/11, D-P1c-3).
 *
 * Beide Consumer-Apps haben keine Credential-Routen mehr; angemeldet wird
 * ausschliesslich auf tools.greenforce.com. Diese Komponente verlaesst die App
 * daher sofort Richtung `tools/login?app=<id>&next=<pfad>`.
 *
 * Der Navigations-Call sitzt in einem Effect, nicht im Render: ein
 * `location.replace()` waehrend des Renderns ist ein Seiteneffekt im
 * Render-Pfad (unter StrictMode doppelt, in einer kuenftigen concurrent-Welt
 * potenziell verworfen). Der Effect laeuft nach dem Commit, genau einmal pro
 * Mount.
 *
 * Bis der Browser die Navigation ausfuehrt, steht ein Lade-Indikator — kein
 * Text-Flash von „nicht angemeldet", denn fachlich passiert hier ein Uebergang,
 * kein Fehler. Markup bewusst inline (statt Import einer LoadingScreen): die
 * fullscreen-Variante ist in `App.tsx` lokal definiert, und Transfer hat gar
 * keine — ein geteiltes Modul dafuer zu extrahieren waere Scope dieses PRs
 * hinaus.
 */
export function ToolsLoginRedirect({ app }: { app: ToolsLoginApp }) {
  useEffect(() => {
    redirectToToolsLogin(app);
  }, [app]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-brand-cream">
      <Spinner size="lg" className="text-brand-green-700" />
      <span className="sr-only">Weiterleitung zur Anmeldung …</span>
    </div>
  );
}
